export default {
  // Navigation
  'nav.residence': 'Residence',
  'nav.gallery': 'Gallery',
  'nav.highlights': 'Highlights',
  'nav.location': 'Location',
  'nav.contact': 'Contact',
  'nav.appointment': 'Appointment',
  'nav.viewing': 'Private Viewing',
  'nav.brochure': 'Brochure',

  // Hero
  'hero.subtitle': 'Private Residence · from CHF 5,800,000',
  'hero.discover': 'Discover',

  // Philosophy
  'philosophy.label': 'The Property',
  'philosophy.stat.area': 'Living Area',
  'philosophy.stat.built': 'Completion',
  'philosophy.stat.price': 'from CHF',

  // Gallery section
  'gallery.label': 'Gallery',
  'gallery.heading': 'A home that speaks.',
  'gallery.rooms': '6 Spaces · 6 Perspectives',
  'gallery.footer.note': 'All images · Placeholder for professional photography',
  'gallery.footer.more': 'Further images on request →',

  // Highlights section
  'highlights.label': 'Features',
  'highlights.heading': 'Highlights of the Residence',
  'highlights.sub': 'Only the essential. Only the extraordinary.',
  'highlights.energyClass': 'Energy Class',
  'highlights.yearBuilt': 'Year Built',
  'highlights.available': 'Availability',
  'highlights.availableValue': 'Immediately',

  // Highlights page
  'highlights.page.label': 'At a Glance',
  'highlights.page.essentials': 'The Essentials',
  'highlights.page.techLabel': 'Technical Data',
  'highlights.page.materialsLabel': 'Materials & Quality',
  'highlights.page.materialsHeading': 'Handpicked Materials',
  'highlights.page.materialsSub': 'Every detail was consciously chosen. Nothing left to chance.',
  'highlights.page.floorplanLabel': 'Floor Plan',
  'highlights.page.floorplanHeading': 'Room Layout',
  'highlights.page.floorplanDesc': 'The detailed floor plan is available to qualified prospects after an initial conversation.',
  'highlights.page.floorplanBtn': 'Request Floor Plan',

  // Location section (home)
  'location.label': 'Location & Surroundings',
  'location.heading': 'Zürichberg — the quiet heart of the city.',
  'location.text': 'Zürichberg ranks among the most exclusive residential locations in Switzerland. Nestled between Lake Zurich and the forest, this location combines absolute privacy with urban proximity. Villas here are rarely, almost never, publicly offered for sale.',
  'location.quote': 'Those who live here no longer need to prove anything.',
  'location.quoteSource': '— Zürichberg, always home to the discreet',
  'location.mapNote': 'Exact address upon request',

  // Location page
  'location.page.title': 'Location & Surroundings',
  'location.page.heading': 'The most coveted address in Switzerland.',
  'location.page.text1': 'Zürichberg ranks among the most exclusive residential locations in Europe. Nestled between Lake Zurich and the old city forest, this address combines urban brevity with maximum retreat — a combination that barely exists on the open market.',
  'location.page.text2': 'Villas here are almost never publicly listed. They change owners discreetly and rarely. The Obsidian Villa is one of these rare exceptions.',
  'location.page.mapLabel': 'Map',
  'location.page.mapAddress': 'Zürichberg, 8044 Zurich',
  'location.page.mapNote': 'Exact address upon request',
  'location.page.neighborhood': 'The Neighborhood',
  'location.page.distances': 'Distances',
  'location.page.privacy': 'Calm & Privacy',
  'location.page.privacyText': 'Zürichberg is deliberately not an entertainment district. It is an address. Visitors come by invitation only.',
  'location.page.education': 'Education & Family',
  'location.page.educationText': 'International schools and excellent gymnasiums nearby — Zurich consistently ranks among the world\'s best.',
  'location.page.nature': 'Nature & Recreation',
  'location.page.natureText': '150 hectares of Zürichberg forest right at your doorstep. Hiking, riding, and tranquility — in the heart of the city.',
  'location.page.culture': 'Culture & Dining',
  'location.page.cultureText': 'The Dolder Grand, Kunsthaus Zürich, and Zurich\'s finest restaurants are just minutes away.',

  // Contact section + page
  'contact.label': 'Contact',
  'contact.viewingLabel': 'Private Viewing',
  'contact.heading': 'For further information and private viewings.',
  'contact.sub': 'We look forward to your discreet inquiry.',
  'contact.introSub': 'We look forward to your discreet inquiry. Our team will personally contact you within 24 hours.',
  'contact.formTitle': 'Your Inquiry',
  'contact.firstName': 'First Name',
  'contact.firstNamePh': 'Your first name',
  'contact.lastName': 'Last Name',
  'contact.lastNamePh': 'Your last name',
  'contact.email': 'E-Mail',
  'contact.emailPh': 'your@email.ch',
  'contact.phone': 'Phone',
  'contact.phoneOpt': 'Phone (optional)',
  'contact.phonePh': '+41 ...',
  'contact.concern': 'Subject',
  'contact.message': 'Your Message',
  'contact.messagePh': 'I am interested in a private viewing...',
  'contact.send': 'Send Inquiry',
  'contact.sending': 'Sending…',
  'contact.thanks': 'Thank you.',
  'contact.thanksText': 'Your inquiry was successfully submitted. Dr. Alexandra Hartmann will contact you personally.',
  'contact.thanksText2': 'Your inquiry has been submitted. We will personally contact you within 24 hours.',
  'contact.discrete': 'Absolutely discreet · No sharing with third parties',
  'contact.discreteFull': 'All inquiries are handled with absolute discretion. Your data will not be shared with third parties.',
  'contact.optViewing': 'Private Viewing',
  'contact.optFloorplan': 'Request Floor Plan',
  'contact.optInfo': 'General Information',
  'contact.optPrice': 'Price Negotiation',
  'contact.office': 'Office',
  'contact.hours': 'Mon–Fri 09:00–18:00',

  // Appointment
  'appointment.label': 'Book Appointment',
  'appointment.heading': 'Schedule a Private Viewing',
  'appointment.sub': 'Choose your preferred date for an exclusive viewing of the Obsidian Villa.',
  'appointment.selectDate': 'Select Date',
  'appointment.selectTime': 'Select Time',
  'appointment.yourData': 'Your Details',
  'appointment.firstName': 'First Name',
  'appointment.firstNamePh': 'Your first name',
  'appointment.lastName': 'Last Name',
  'appointment.lastNamePh': 'Your last name',
  'appointment.email': 'E-Mail',
  'appointment.emailPh': 'your@email.ch',
  'appointment.phone': 'Phone',
  'appointment.phonePh': '+41 ...',
  'appointment.note': 'Notes (optional)',
  'appointment.notePh': 'Special requests or questions...',
  'appointment.send': 'Request Appointment',
  'appointment.sending': 'Sending…',
  'appointment.thanks': 'Appointment Requested.',
  'appointment.thanksText': 'We will personally contact you within 24 hours to confirm your appointment.',
  'appointment.discrete': 'Absolutely discreet · Confirmation within 24h',
  'appointment.selectedDate': 'Selected Date',
  'appointment.selectedTime': 'Selected Time',

  // Gallery page
  'galerie.title': 'Gallery',
  'galerie.label': 'The Obsidian Villa',
  'galerie.filter.all': 'All',
  'galerie.filter.outside': 'Exterior',
  'galerie.filter.inside': 'Interior',
  'galerie.filter.details': 'Details',
  'galerie.photos': 'Photos',
  'galerie.moreOnRequest': 'Additional photos available upon request',

  // Footer
  'footer.tagline': 'Exclusive properties for discerning buyers. Discretion. Quality. Trust.',
  'footer.navigation': 'Navigation',
  'footer.contact': 'Contact',
  'footer.copyright': '© 2026 The Obsidian Villa · All Rights Reserved',
  'footer.studio': 'Design study by',

  // PDF
  'pdf.download': 'Brochure',
  'pdf.downloading': 'Creating…',

  // Property tagline & description
  'property.tagline': 'Where architecture meets the art of living.',
  'property.description': 'Amid the silent greenery of Zürichberg, a space unfolds that makes time stand still. The light falls differently here — slowly, golden, like a quiet promise. The Obsidian Villa is not a property. It is a feeling. A composition of silence, material and views that discerning people understand without needing explanation.',

  // Highlight labels
  'prop.label.area': 'Living Area',
  'prop.label.plot': 'Plot',
  'prop.label.bedrooms': 'Bedrooms',
  'prop.label.bathrooms': 'Bathrooms',
  'prop.label.year': 'Year Built',
  'prop.label.pool': 'Pool',
  'prop.label.view': 'Lake View',
  'prop.label.garage': 'Garage',

  // Highlight values (text-based)
  'prop.val.bathrooms': '7 Full Baths',
  'prop.val.pool': 'Heated Infinity Pool',
  'prop.val.view': 'Lake Zurich Panorama',
  'prop.val.garage': '4 Vehicles',

  // Location distances
  'location.page.walking': 'On foot',
  'location.page.byCar': 'By car',

  // Spec categories
  'spec.cat.area': 'Living Area',
  'spec.cat.rooms': 'Rooms',
  'spec.cat.features': 'Features',
  'spec.cat.quality': 'Build Quality',

  // Spec item labels
  'spec.totalArea': 'Total Living Area',
  'spec.usableArea': 'Usable Area',
  'spec.plot': 'Plot',
  'spec.bedrooms': 'Bedrooms',
  'spec.bathrooms': 'Bathrooms',
  'spec.guestRooms': 'Guest Rooms',
  'spec.pool': 'Pool',
  'spec.garage': 'Garage',
  'spec.wellness': 'Wellness',
  'spec.year': 'Year Built',
  'spec.energyClass': 'Energy Class',
  'spec.heating': 'Heating System',

  // Spec values (text)
  'spec.val.bathrooms': '7 Full Baths',
  'spec.val.pool': 'Heated Infinity Pool',
  'spec.val.garage': '4 Vehicles',
  'spec.val.wellness': 'Spa & Sauna',
  'spec.val.heating': 'Heat Pump',

  // Material names
  'mat.flooring': 'Flooring',
  'mat.kitchen': 'Kitchen',
  'mat.bathroom': 'Bathroom',
  'mat.smarthome': 'Smart Home',
  'mat.security': 'Security',
  'mat.glazing': 'Glazing',
};
